import { IFormMetricsIn } from "../../models/input/surveyApi/IFormMetricsIn";
import * as ApiWithToken from "../callApiWithToken";

const metricService = {
  getMetricSosPrintBySubRegion: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricSosPrintBySubRegion?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}`
    );
  },
  getMetricSosPcBySubRegion: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricSosPcBySubRegion?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName} `
    );
  },
  getMetricEsfCoverageBySubRegionWeb: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricEsfCoverageBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName} `
    );
  },
  GetMetricCheckInBySubRegionWeb: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricCheckInBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}&promotorName=${form.promotorName} `
    );
  },
  getMetricTrainigMaterialBySubRegionWeb: async function (
    form: IFormMetricsIn
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricTrainigMaterialBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}&promotorName=${form.promotorName} `
    );
  },
  getMetricVisualPcBySubRegionWeb: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricVisualPcBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}`
    );
  },
  getMetricAbsenceSchedulingBySubRegionWeb: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricAbsenceSchedulingBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}&promotorName=${form.promotorName}`
    );
  },
  getMetricAbsenceCheckInBySubRegionWeb: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricAbsenceBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}&promotorName=${form.promotorName}`
    );
  },
  getMetricSyncBySubRegionWeb: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricSyncBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}&promotorName=${form.promotorName}`
    );
  },
  getMetricVisualPrintBySubRegionWeb: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricVisualPrintBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}`
    );
  },
  getMetricVisualPcStatusBySubRegionWeb: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricVisualPcStatusBySubRegionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}`
    );
  },
  getMetricVisualPrintStatusBySubregionWeb: async function (
    form: IFormMetricsIn
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricVisualPrintStatusBySubregionWeb?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}`
    );
  },
  getMetricByAdvisor: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricByAdvisor?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}`
    );
  },
  GetMetricByPos: async function (form: IFormMetricsIn) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `Metrics/GetMetricByPos?page=${form.page}&rowCount=${form.rowCount}&startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}`
    );
  },
  downloadMetric: async function (form: IFormMetricsIn) {
    if (form.promotorName === undefined) {
      return ApiWithToken.getApiBlob(
        process.env.REACT_APP_SURVEY_API +
          `DownloadMetrics/${form.sp}?startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}&languageID=${form.languageID}`
      );
    } else {
      return ApiWithToken.getApiBlob(
        process.env.REACT_APP_SURVEY_API +
          `DownloadMetrics/${form.sp}?startDate=${form.startDate}&endDate=${form.endDate}&coordinatorId=${form.coordinatorId}&supervisorId=${form.supervisorId}&supervisorName=${form.supervisorName}&promotorName=${form.promotorName}&languageID=${form.languageID}`
      );
    }
  },
};
export default metricService;
